import { ReactNode } from 'react';
import { InvoiceStatusV2, InvoiceV2 } from '@/store/invoice/useGetInvoicesV2';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 10;
export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];
export const EXPORT_PER_PAGE = 100;

export const INVOICE_MONITORED_FIELDS = [
    'month',
    'status',
    'storeId',
    'stores',
    'shopManagerId',
    'email',
];

export const NEW_INVOICE_SUPPORT_URL =
    'https://wa.me/558521807303?text=Ol%C3%A1!%20Gostaria%20de%20solicitar%20a%20emiss%C3%A3o%20de%20um%20novo%20boleto%2C%20pois%20o%20anterior%20expirou';

export const isExpiredInvoice = (row: Pick<InvoiceV2, 'status' | 'barcode'>) =>
    row.status === 'ATRASADO' && !row.barcode;

export const STATUS_CONFIG: Record<
    InvoiceStatusV2,
    { label: string; tagColor: string; dot: string }
> = {
    AVENCER: { label: 'A vencer', tagColor: 'default', dot: '#bfbfbf' },
    VENCEHOJE: { label: 'Vence hoje', tagColor: 'orange', dot: '#fa8c16' },
    ATRASADO: { label: 'Atrasado', tagColor: 'gold', dot: '#faad14' },
    PAGTO_PARCIAL: { label: 'Pago parcial', tagColor: 'blue', dot: '#1677ff' },
    PAGO: { label: 'Pago', tagColor: 'green', dot: '#52c41a' },
};

export const STATUS_OPTIONS = (
    Object.keys(STATUS_CONFIG) as InvoiceStatusV2[]
).map((value) => ({
    value,
    label: STATUS_CONFIG[value].label,
    dot: STATUS_CONFIG[value].dot,
}));

export const ADMIN_STATUS_OPTIONS: { value: string; label: ReactNode }[] = [
    { value: 'PAGO', label: 'Pago' },
    { value: 'CANCELADO', label: 'Cancelado' },
    { value: 'VENCEHOJE', label: 'Vence Hoje' },
    { value: 'AVENCER', label: 'À Vencer' },
    { value: 'ATRASADO', label: 'Atrasado' },
    { value: 'PAGTO_PARCIAL', label: 'Parcialmente Pago' },
];
